import React from 'react'
import Footer from './Footer'
import { useEffect,useState } from 'react';

const ShipingDelivery = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
             window.scrollTo({ top: 0, behavior: 'auto' });
     
             const toggleVisibility = () => {
                 if (window.pageYOffset > 300) {
                     setIsVisible(true);
                 } else {
                     setIsVisible(false);
                 }
             };
     
             window.addEventListener('scroll', toggleVisibility);
     
             return () => {
                 window.removeEventListener('scroll', toggleVisibility);
             };
         }, []);
  return (
    <>
      <div class="policy-card">
  <h3>Shipping and Delivery</h3>

  <p>
    For International buyers, orders are shipped and delivered through registered international courier companies and/or International speed post only. For domestic buyers, orders are shipped through registered domestic courier companies and/or speed post only. Orders are shipped within 0-7 days or as per the delivery date agreed at the time of order confirmation and delivering of the shipment subject to Courier Company / post office norms.
  </p>

  <p>
    <strong>OVERAY PRIVATE LIMITED</strong> is not liable for any delay in delivery by the courier company / postal authorities and only guarantees to hand over the consignment to the courier company or postal authorities within 0-7 days from the date of the order and payment or as per the delivery date agreed at the time of order confirmation. Delivery of all orders will be to the address provided by the buyer.
  </p>

  <p>
    Delivery of our services will be confirmed on your mail ID as specified during registration. For any issues in utilizing our services you may contact our helpdesk on <strong>8433314555</strong> or <strong>overaypvtltd@gmail.com</strong>.
  </p>
</div>
      <Footer/>
    </>
  )
}

export default ShipingDelivery
